export default __webpack_public_path__ + "static/media/tapwar-logo.c181612b.svg";